export const settingsActionsLists = {
    loadLanguages: "settings/loadLanguages"
} as const;
